import { render, staticRenderFns } from "./InlineEditorBackdrop.vue?vue&type=template&id=22d2095e&"
import script from "./InlineEditorBackdrop.vue?vue&type=script&lang=ts&"
export * from "./InlineEditorBackdrop.vue?vue&type=script&lang=ts&"
import style0 from "./InlineEditorBackdrop.vue?vue&type=style&index=0&id=22d2095e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports